import { Component } from '@angular/core';

@Component({
  selector: 'app-ngb-tooltip-demo',
  templateUrl: './tooltip-demo.component.html',
})
export class NgbTooltipDemoComponent {}
